import React from 'react';
import Card from "react-bootstrap/Card";
import projImg2 from "../../assets/img/n2.png";
import ShowMoreText from "react-show-more-text";
import projectimage2 from "../../assets/img/np2.png";

const Card2 = () => {
    // Your component logic here
    return (
        <Card className="CARD2" bg="dark">
              {/* <Card.Title><h2>Analyzing the competition in the Hungarian fuel market</h2></Card.Title> */}

              <Card.Img variant="top" src={projectimage2} />

              <Card.Body>
                <Card.Text>
                  {" "}
                  <img className="img2" src={projImg2} />{" "}
                  <p className="text7">Gergely Buday</p>
                  <br />
                  <p className="text8">
                    Research Assistant
                    <br /> Univesity of Sheffield
                  </p>
                  {/*  <p className="text7">Supervisor:Dr. Mihály Szabó</p><br/>
               <p className="text7">Rector's delegate. Rector's Office Directorate of Education, BME</p> */}
                  {/* <img className="img2" src={projImg21}/> */}
                </Card.Text>
                <ShowMoreText lines={2}>
                  <div>
                    Formal verification using theorem provers is a challenging
                    subject. It has become mature so it is not confined to
                    universities. Research laboratories and innovative companies
                    pursue this area. The most popular provers are Isabelle, Coq
                    and Lean, with various strengths and drawbacks. The project
                    will be tailored to the skills of the student, however,
                    being able to learn new programming languages on their own
                    is expected. Naturally, with the help of the supervisor.
                    Understanding the basics of functional programming, formal
                    logic and type systems is an advantage. Students interested
                    in mathematics can do formalisation, those who interested in
                    practical problems can do verification, which naturally
                    contains the former, formalising classical or novel
                    mathematics.
                    <br />
                    <br />
                    References:{" "}
                    <ul>
                      <li>
                        <a href="https://datatracker.ietf.org/rg/ufmrg/about/">
                          Usable Formal Methods Proposed Research Group
                        </a>
                      </li>
                      <li>
                        Internet Message Access Protocol (IMAP),
                        <span className="text9">
                          {" "}
                          <a href="https://datatracker.ietf.org/doc/rfc9051/">
                            RFC 9051
                          </a>
                        </span>
                      </li>
                      <li>
                        {" "}
                        <a href="https://isabelle.in.tum.de/">
                          sabelle home page
                        </a>
                      </li>
                      <li>
                        <a href="http://concrete-semantics.org/">
                          Concrete Semantics, especially Part I
                        </a>
                      </li>
                    </ul>
                  </div>
                </ShowMoreText>
              </Card.Body>
            </Card>
    );
};

export default Card2;
